import React from "react";

const Body = (props) => {
  return <div className="content-wrapper">{props.children}</div>;
};

export default Body;
